import { createFileRoute } from "@tanstack/react-router";

const META_TAG = `<meta name="google-site-verification" content="xVwYbHwPlAX5_kT4W18BYD-xFDoxtlxSbzpkG4C_-60" />`;
const HTML_FILE_URL = "https://vendingmachinefree.com/google72b9c75a1471797d.html";
const HTML_FILE_CONTENT = `google-site-verification: google72b9c75a1471797d.html`;

export const Route = createFileRoute("/verification")({
  component: VerificationPage,
  head: () => ({
    meta: [
      { title: "Search Console Verification — Vending Machine Free.com" },
      { name: "robots", content: "noindex,nofollow" },
      { name: "description", content: "Internal verification reference page." },
      {
        name: "google-site-verification",
        content: "xVwYbHwPlAX5_kT4W18BYD-xFDoxtlxSbzpkG4C_-60",
      },
    ],
  }),
});

function Block({ label, value }: { label: string; value: string }) {
  return (
    <div className="mb-6">
      <div className="mb-2 text-sm font-semibold text-slate-700">{label}</div>
      <pre className="overflow-x-auto rounded-md border border-slate-300 bg-slate-50 p-3 text-xs text-slate-900">
        <code>{value}</code>
      </pre>
      <button
        onClick={() => navigator.clipboard.writeText(value)}
        className="mt-2 rounded-md bg-slate-900 px-3 py-1.5 text-xs font-medium text-white hover:bg-slate-700"
      >
        Copy
      </button>
    </div>
  );
}

function VerificationPage() {
  return (
    <main className="mx-auto max-w-3xl px-6 py-12">
      <h1 className="mb-2 text-2xl font-bold">Google Search Console Verification</h1>
      <p className="mb-8 text-sm text-slate-600">
        Both verification methods are live on this site. Use either one in Search Console.
      </p>

      <h2 className="mb-3 text-lg font-semibold">Method 1 — HTML meta tag</h2>
      <Block label="Paste into Search Console (HTML tag method)" value={META_TAG} />
      <p className="mb-8 text-xs text-slate-600">
        This tag is rendered in the <code>&lt;head&gt;</code> of every page via
        <code> src/routes/__root.tsx</code>.
      </p>

      <h2 className="mb-3 text-lg font-semibold">Method 2 — HTML file upload</h2>
      <Block label="File URL (must return 200)" value={HTML_FILE_URL} />
      <Block label="File contents" value={HTML_FILE_CONTENT} />
      <p className="text-xs text-slate-600">
        Served from <code>public/google72b9c75a1471797d.html</code>.
      </p>
    </main>
  );
}
